import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import Link from 'redux-first-router-link';
import { translate, prefix } from '../../../utils/string';
import { purifier } from '../../../utils/dom';
import s from './Text.scss';

const CaptionLink = ({ content, setup, linkNumber = '' }) => {
	const link = content[`linkText${linkNumber}`] ? translate(setup, content[`linkText${linkNumber}`]) : null;
	const linkStyles = {};
	const isButton = (content.linkStyles.background && content.linkStyles.background !== 'transparent') || (content.linkStyles.border && content.linkStyles.border !== 'transparent');

	if (content.linkStyles.background) linkStyles.backgroundColor = content.linkStyles.background;
	if (content.linkStyles.border) linkStyles.borderColor = content.linkStyles.border;
	if (content.linkStyles.text) linkStyles.color = content.linkStyles.text;

	return <Link className={[s.text_link, (isButton ? s.text_link__button : null)].join(' ')} style={{ ...linkStyles }} to={prefix(setup, translate(setup, content[`link${linkNumber}`]))}><span>{ link }</span></Link>;
};

const Links = ({ content, setup, magazine, isOpen }) => {
	if (magazine && !isOpen) return null;
	if (content.doubleLink && content.link && content.linkText && content.link2 && content.linkText2) {
		return (
			<div className={s.text_doubleLink}>
				<div className={s.text_doubleLink_inner}>
					<CaptionLink content={content} setup={setup} />
				</div>
				<div className={s.text_doubleLink_inner}>
					<CaptionLink content={content} setup={setup} linkNumber="2" />
				</div>
			</div>
		);
	}
	if (content.link && content.linkText) return <CaptionLink content={content} setup={setup} />;

	return null;
};

class Text extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
		};
	}

	seeAllBody = (e) => {
		e.preventDefault();

		this.setState({
			isOpen: true,
		});
	}

	render() {
		const { content = {}, setup, magazine, list } = this.props;
		const { isOpen } = this.state;

		const HeaderTag = content.headerDetails.type;
		const headerText = content.headerText ? <HeaderTag className={[s.text_headline, `u_font__${content.headerDetails.font}`, `u_fontSize__${content.headerDetails.size}`].join(' ')}>{ translate(setup, content.headerText) }</HeaderTag> : null;

		const bodyClasses = [s.text_body, `u_font__${content.bodyDetails.font}`, `u_fontSize__${content.bodyDetails.size}`];
		if (content.bodyDetails.columns) bodyClasses.push(s.text_body__columns);

		const bodyText = content.body ? <div className={bodyClasses.join(' ')} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, content.body), { ADD_TAGS: ['iframe', 'script'], KEEP_CONTENT: false }) }} /> : null;

		return (
			<div className={s.text} style={{ textAlign: content.align?.horizontal }}>
				{ !list && content.preHeader && <h4 className={s.text_preHeader}>{ translate(setup, content.preHeader) }</h4> }
				{ !list && headerText }
				{ content.ingress ? <div className={[s.text_body, s.text_body__ingress].join(' ')} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, content.ingress)) }} /> : null }
				{ bodyText }
				<Links content={content} setup={setup} magazine={magazine} isOpen={isOpen} />
			</div>
		);
	}
}

export default hot(module)(Text);
